/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { WorkPermitListContainer } from './container';
import { useNavigate } from 'react-router-dom';

export const WorkPermitListPage = ({ navigation }: { navigation: any }) => {
  const navigate = useNavigate();

  return (
    <WorkPermitListContainer
      onViewClick={(id: any,type:string) => {
        console.log('Expired WP list container ID', id,type);
        navigate(`/applications?credential=${id}`, {
          state: { from: 'renew', type:type },
        });
      }}
    />
  );
};
